import React, { Fragment } from "react";
import Carousel from "react-multi-carousel";
import MultiCarouselProduct from './MultiCarouselProduct';
import MultiCarouselBrand from './MultiCarouselBrand';

class MultiCarousel extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            isMounted: false,
        };

        let responsiveness = {
            desktop: {
                breakpoint: { max: 3000, min: 1024 },
                items: 4,
                slidesToSlide: 4,
            },
            tablet: {
                breakpoint: { max: 1024, min: 464 },
                items: 3,
                slidesToSlide: 3,
                // partialVisibilityGutter: 30
            },
            mobile: {
                breakpoint: { max: 464, min: 0 },
                items: 2,
                slidesToSlide: 2,
            }
        }
        this.settings = {
            infinite: true,
            swipeable: true,
            draggable: false,
            showDots: false,
            arrows: false,
            responsive: responsiveness,
            keyBoardControl: true,
            transitionDuration: 500,
            itemClass: "carousel-item",
            partialVisible: false,
            minimumTouchDrag: 10,
            renderButtonGroupOutside: true,
            transitionDuration: 300
        }
    }
    componentDidMount() {
        if (this.props.items) {
            this.setState({
                isMounted: true,
            });
        }
    }

    renderSwitch(item, index, itemType, onClick) {
        switch (itemType) {
            case 'product':
                return <MultiCarouselProduct item={item} index={index} onClick={onClick} ></MultiCarouselProduct>;
            case 'brand':
                return <MultiCarouselBrand item={item} index={index} ></MultiCarouselBrand>;
            default:
                return <MultiCarouselProduct item={item} index={index} onClick={onClick} ></MultiCarouselProduct>;
        }
    }

    render() {
        const { itemType, onClick, responsivestyle } = this.props;

        if(responsivestyle) {
            this.settings.responsive = responsivestyle;
        }

        return (
            <Fragment>
                <Carousel {...this.settings} customButtonGroup={<CustomButtonGroupAsArrows />}>
                    {this.state.isMounted && this.props.items.map((item, index) => {
                        return (
                            <Fragment key={index}>
                                {/* <MultiCarouselProduct item={item} index={index} ></MultiCarouselProduct> */}
                                {this.state.isMounted && this.renderSwitch(item, index, itemType, onClick)}
                            </Fragment>
                        )
                    })}
                </Carousel>
            </Fragment>
        );
    }
}

const CustomButtonGroupAsArrows = ({ next, previous, carouselState }) => {
    return (
        <Fragment>
            {carouselState.totalItems > carouselState.slidesToShow &&
                <div className="multi-carousel__buttons">
                    <button className="react-multiple-carousel__arrow react-multiple-carousel__arrow--left" onClick={previous}></button>
                    <button className="react-multiple-carousel__arrow react-multiple-carousel__arrow--right" onClick={next}></button>
                </div>
            }
        </Fragment>
    );
};

export default MultiCarousel;